/// Port of mobile/lib/user/domain/user.dart.
///
/// The API returns snake_case `high_score`; locally stored guests use
/// `highScore`. Both are accepted, as in the Dart original.

export interface User {
  id: string;
  email: string;
  username: string;
  highScore: number;
  isAnonymous: boolean;
  hasPassword: boolean;
  emailVerified: boolean;
  providers: string[];
}

export function anonymousUser(highScore = 0): User {
  return {
    id: '',
    email: '',
    username: 'Guest',
    highScore,
    isAnonymous: true,
    hasPassword: false,
    emailVerified: false,
    providers: [],
  };
}

export function userFromJson(json: Record<string, unknown>): User {
  const rawProviders = json.providers;
  const providers: string[] = [];
  if (Array.isArray(rawProviders)) {
    for (const item of rawProviders) {
      if (typeof item === 'string' && item.length > 0) providers.push(item);
    }
  }
  return {
    id: typeof json.id === 'string' ? json.id : '',
    email: typeof json.email === 'string' ? json.email : '',
    username: typeof json.username === 'string' ? json.username : 'Guest',
    highScore: readInt(json.high_score ?? json.highScore),
    isAnonymous: json.isAnonymous === true,
    hasPassword: json.has_password === true || json.hasPassword === true,
    emailVerified: json.email_verified === true || json.emailVerified === true,
    providers,
  };
}

function readInt(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value) ? Math.trunc(value) : 0;
}

export interface Ranking {
  id: string;
  username: string;
  highScore: number;
  rank: number;
}

export function rankingFromJson(json: Record<string, unknown>): Ranking {
  return {
    id: typeof json.id === 'string' ? json.id : '',
    username: typeof json.username === 'string' ? json.username : 'Guest',
    highScore: readInt(json.high_score ?? json.highScore),
    rank: readInt(json.rank),
  };
}
